// ==========================================================================
// Rebuy - Eurus Theme Dynamic Integration
// Dynamically applies theme classes and functionality to Rebuy widgets
// ==========================================================================

document.addEventListener('DOMContentLoaded', function() {
    console.log('Rebuy theme integration loading...');
    
    // Create a MutationObserver to watch for Rebuy widget loading
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1 && node.classList && node.classList.contains('rebuy-widget')) {
                        console.log('Rebuy widget detected:', node);
                        initializeRebuyWidget(node);
                    }
                });
            }
        });
    });
    
    // Start observing the document for Rebuy widgets
    observer.observe(document.body, { childList: true, subtree: true });
    
    // Also check for existing widgets
    document.querySelectorAll('.rebuy-widget').forEach(widget => {
        initializeRebuyWidget(widget);
    });
});

function initializeRebuyWidget(widget) {
    console.log('Initializing Rebuy widget:', widget);
    
    // Apply theme section classes
    applyThemeSectionStyles(widget);
    
    // Setup product cards when products are loaded
    const productObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.addedNodes.length) {
                setupProductCards(widget);
            }
        });
    });
    
    productObserver.observe(widget, { childList: true, subtree: true });
    
    // Initial setup if products already exist
    setupProductCards(widget);
}

function applyThemeSectionStyles(widget) {
    // Get theme's section classes from existing sections
    const themeSections = document.querySelectorAll('[id^="shopify-section-"]');
    let sectionClasses = [];
    
    if (themeSections.length > 0) {
        // Extract common section classes
        themeSections.forEach(section => {
            const classes = Array.from(section.classList).filter(cls => 
                cls.includes('section') || cls.includes('container') || cls.includes('padding')
            );
            sectionClasses = [...new Set([...sectionClasses, ...classes])];
        });
    }
    
    // Apply theme section classes to Rebuy widget
    widget.classList.add('shopify-section', 'index-section');
    
    // Wrap content in theme container if needed
    if (!widget.querySelector('.wrapper')) {
        const wrapper = document.createElement('div');
        wrapper.className = 'wrapper';
        while (widget.firstChild) {
            wrapper.appendChild(widget.firstChild);
        }
        widget.appendChild(wrapper);
    }
}

function setupProductCards(widget) {
    const products = widget.querySelectorAll('.rebuy-product-block');
    console.log('Setting up', products.length, 'product cards');
    
    products.forEach((product) => {
        if (product.dataset.themeEnhanced) return;
        
        // Transform to match theme's product card structure
        transformProductCard(product);
        
        // Apply theme interactions
        applyThemeInteractions(product);
        
        product.dataset.themeEnhanced = 'true';
    });
}

function transformProductCard(product) {
    // Get theme's product card structure from existing products
    const themeProductCard = document.querySelector('.product-card:not(.rebuy-product-block)');
    
    if (themeProductCard) {
        // Clone theme structure
        const structure = themeProductCard.cloneNode(true);
        
        // Map Rebuy elements to theme elements
        mapRebuyToTheme(product, structure);
    } else {
        // Fallback: Apply theme classes directly
        applyDirectThemeClasses(product);
    }
}

function mapRebuyToTheme(rebuyProduct, themeStructure) {
    // Extract Rebuy data
    const rebuyData = {
        image: rebuyProduct.querySelector('.rebuy-product-image img'),
        title: rebuyProduct.querySelector('.rebuy-product-title'),
        price: rebuyProduct.querySelector('.rebuy-product-price'),
        button: rebuyProduct.querySelector('.rebuy-button'),
        select: rebuyProduct.querySelector('.rebuy-select'),
        link: rebuyProduct.querySelector('.rebuy-product-image')
    };
    
    // Apply theme classes
    rebuyProduct.className = themeStructure.className + ' rebuy-product-block';
    
    // Restructure to match theme
    rebuyProduct.innerHTML = '';
    
    // Media container
    const mediaContainer = document.createElement('div');
    mediaContainer.className = 'product-card__media media media--portrait relative';
    
    if (rebuyData.image) {
        const imageWrapper = document.createElement('div');
        imageWrapper.className = 'product-card__image';
        
        const imgElement = rebuyData.image.cloneNode(true);
        imgElement.className = 'img-product w-full h-full object-cover';
        
        imageWrapper.appendChild(imgElement);
        mediaContainer.appendChild(imageWrapper);
    }
    
    // Add theme quick view button
    const quickViewButton = createThemeQuickViewButton();
    mediaContainer.appendChild(quickViewButton);
    
    rebuyProduct.appendChild(mediaContainer);
    
    // Product info
    const infoContainer = document.createElement('div');
    infoContainer.className = 'product-card__info text-center mt-4';
    
    if (rebuyData.title) {
        const titleElement = document.createElement('h3');
        titleElement.className = 'product-card__name text-base font-normal mb-2';
        
        const titleLink = document.createElement('a');
        titleLink.href = rebuyData.title.href || '#';
        titleLink.className = 'text-current hover:text-primary transition-colors';
        titleLink.textContent = rebuyData.title.textContent;
        
        titleElement.appendChild(titleLink);
        infoContainer.appendChild(titleElement);
    }
    
    if (rebuyData.price) {
        const priceElement = document.createElement('div');
        priceElement.className = 'product-card__price price text-lg font-semibold';
        priceElement.innerHTML = rebuyData.price.innerHTML;
        infoContainer.appendChild(priceElement);
    }
    
    rebuyProduct.appendChild(infoContainer);
    
    // Add to cart button or options
    if (rebuyData.select && rebuyData.select.options.length > 1) {
        const optionsButton = createThemeOptionsButton();
        rebuyProduct.appendChild(optionsButton);
    } else if (rebuyData.button) {
        const cartButton = createThemeCartButton(rebuyData.button);
        rebuyProduct.appendChild(cartButton);
    }
}

function applyDirectThemeClasses(product) {
    // Apply theme classes directly to Rebuy elements
    product.classList.add('product-card', 'item', 'relative');
    
    const media = product.querySelector('.rebuy-product-media');
    if (media) {
        media.classList.add('product-card__media', 'media', 'media--portrait', 'relative');
    }
    
    const image = product.querySelector('.rebuy-product-image');
    if (image) {
        image.classList.add('product-card__image');
        const img = image.querySelector('img');
        if (img) {
            img.classList.add('img-product', 'w-full', 'h-full', 'object-cover');
        }
    }
    
    const info = product.querySelector('.rebuy-product-info');
    if (info) {
        info.classList.add('product-card__info', 'text-center', 'mt-4');
    }
    
    const title = product.querySelector('.rebuy-product-title');
    if (title) {
        title.classList.add('product-card__name', 'text-base', 'font-normal', 'mb-2');
    }
    
    const price = product.querySelector('.rebuy-product-price');
    if (price) {
        price.classList.add('product-card__price', 'price', 'text-lg', 'font-semibold');
    }
    
    const button = product.querySelector('.rebuy-button');
    if (button) {
        button.classList.add('btn', 'btn--primary', 'w-full', 'mt-4');
    }
}

function createThemeQuickViewButton() {
    const container = document.createElement('div');
    container.className = 'button-quickview-icon absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity';
    
    const button = document.createElement('button');
    button.className = 'label-btn-quickview button-disable-effect not-icon button--quickview rounded-full bg-white p-3 border border-gray-200 hover:border-primary';
    button.setAttribute('aria-label', 'Quick view');
    button.innerHTML = `
        <span class="w-4 h-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 16 16" fill="none">
                <path d="M7.67451 13.8502C11.0849 13.8502 13.8496 11.0855 13.8496 7.67508C13.8496 4.26468 11.0849 1.5 7.67451 1.5C4.2641 1.5 1.49942 4.26468 1.49942 7.67508C1.49942 11.0855 4.2641 13.8502 7.67451 13.8502Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14.5003 14.5L13.2003 13.2" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </span>
    `;
    
    container.appendChild(button);
    return container;
}

function createThemeOptionsButton() {
    const container = document.createElement('div');
    container.className = 'quick-view-container absolute bottom-4 left-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity';
    
    const button = document.createElement('button');
    button.className = 'btn btn--secondary w-full';
    button.textContent = 'Choose options';
    
    container.appendChild(button);
    return container;
}

function createThemeCartButton(originalButton) {
    const button = originalButton.cloneNode(true);
    button.className = 'btn btn--primary w-full mt-4';
    return button;
}

function applyThemeInteractions(product) {
    // Use Alpine.js if available (theme uses it)
    if (window.Alpine) {
        product.setAttribute('x-data', `{
            hover: false,
            quickView: false,
            loading: false
        }`);
        
        product.setAttribute('@mouseenter', 'hover = true');
        product.setAttribute('@mouseleave', 'hover = false');
        
        // Add quick view functionality
        const quickViewBtn = product.querySelector('.button-quickview-icon button');
        if (quickViewBtn) {
            quickViewBtn.setAttribute('@click', 'handleQuickView($event, $el)');
            
            // Add handler to the product
            product.setAttribute('x-init', `
                window.handleQuickView = function(event, element) {
                    event.preventDefault();
                    event.stopPropagation();
                    
                    // Use theme's quick view store if available
                    if (Alpine.store('xQuickView')) {
                        const url = element.closest('.rebuy-product-block').querySelector('a').href;
                        Alpine.store('xQuickView').load(url, element);
                        Alpine.store('xQuickView').open();
                    }
                }
            `);
        }
    } else {
        // Fallback for non-Alpine interactions
        applyFallbackInteractions(product);
    }
}

function applyFallbackInteractions(product) {
    const quickViewBtn = product.querySelector('.button-quickview-icon button');
    if (quickViewBtn) {
        quickViewBtn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            const productLink = product.querySelector('a');
            if (productLink && productLink.href) {
                // Use existing theme quick view if available
                if (window.xQuickView && window.xQuickView.load) {
                    window.xQuickView.load(productLink.href);
                } else {
                    // Fallback implementation
                    console.log('Quick view not available, implementing fallback');
                }
            }
        });
    }
    
    // Hover effects
    product.addEventListener('mouseenter', () => {
        product.classList.add('hover');
    });
    
    product.addEventListener('mouseleave', () => {
        product.classList.remove('hover');
    });
}

// Theme-specific helpers
function inheritThemeStyles() {
    // Find theme's product grid and copy computed styles
    const themeGrid = document.querySelector('.product-grid:not(.rebuy-product-grid)');
    const rebuyGrid = document.querySelector('.rebuy-product-grid');
    
    if (themeGrid && rebuyGrid) {
        const computedStyles = window.getComputedStyle(themeGrid);
        
        // Copy grid styles
        rebuyGrid.style.display = computedStyles.display;
        rebuyGrid.style.gridTemplateColumns = computedStyles.gridTemplateColumns;
        rebuyGrid.style.gap = computedStyles.gap;
        rebuyGrid.style.padding = computedStyles.padding;
        
        // Copy responsive behavior
        rebuyGrid.className = themeGrid.className + ' rebuy-product-grid';
    }
}

// Initialize theme inheritance
document.addEventListener('DOMContentLoaded', () => {
    inheritThemeStyles();
    
    // Re-inherit on resize for responsive behavior
    window.addEventListener('resize', () => {
        inheritThemeStyles();
    });
});